import React from 'react';
import MeterProductPage from '../meter-product-page';

import bgImg from '../../../assets/product-interaction/ddsu5168/ddsu5168_background.png';
import logoImg from '../../../assets/product-interaction/ddsu5168/ddsu5168_logo_white.png';
import qrImg from '../../../assets/product-interaction/ddsu5168/ddsu5168_qr_code.jpg';
import productImg from '../../../assets/product-interaction/ddsu5168-4p/ge400.png';

const GE400 = () => (
  <MeterProductPage
    documentTitle="GE400｜智能计量母表网关"
    bgImg={bgImg}
    logoImg={logoImg}
    productImg={productImg}
    productImageStyle={{ objectFit: 'cover', objectPosition: 'center 82%' }}
    qrImg={qrImg}
    model="GE400"
    productName="智能计量母表网关"
    slogan="多表采集 · 集中上云"
    tags={['RS485', '4G', '蓝牙']}
    manualUrl="http://m.joymeter.com/manual?code=GE400-700-001"
    wiringUrl="/product/ge400/wiring"
  />
);

export default GE400;
